<template>
    <div>
        <div class="row mt-3 pl-0 pl-md-5 pl-lg-0">
            <div class="col-12 col-lg-6 d-flex flex-lg-column flex-row align-items-center">
                <b>{{ $t('AppImplementMeasurementsPlatformView.Engate') }}:</b>
                <div class="pl-2 pl-lg-0">
                    {{ connectorTypeSelected.name }}
                </div>
            </div>
            <div class="col-12 col-lg-6 d-flex flex-lg-column flex-row align-items-center">
                <b>{{ $t('AppImplementMeasurementsPlatformView.Operação') }}:</b>
                <div class="pl-2 pl-lg-0">
                    {{ culturePracticeSelected.text }}
                </div>
            </div>
        </div>
        <div class="row mt-4 mb-2">
            <div class="col-12 col-lg-6 d-flex flex-column align-items-center">
                <b>{{ $t('AppImplementMeasurementsPlatformView.Distância da plataforma') }}:</b>
                <img class="image" src="@/assets/images/implement/platform-erp_x.png">
                {{ measurements.function[0].erp[0] + ' cm' }}
            </div>
            <div class="col-12 col-lg-6 d-flex flex-column align-items-center mt-3 mt-lg-0">
                <b>{{ $t('AppImplementMeasurementsPlatformView.Largura de trabalho') }}:</b>
                <img class="image" src="@/assets/images/implement/platform-width.png">
                {{ measurements.function[0].width + ' cm' }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        connectorTypeSelected: {
            type: Object,
            required: true
        },
        culturePracticeSelected: {
            type: Object,
            required: true
        },
        measurements: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss">
.image {
    max-width: 15vw;
}
@media (max-width: 758px) {
    .image {
        max-width: 60vw;
    }
}
@media (max-width: 1024px) and (min-width: 758px) {
    .image {
        max-width: 25vw;
    }
}
</style>
